import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

// Demos Pages
const EduNavHome = lazy(() => import('@/app/demos/edunav/home/page'))

// pages

const Detail = lazy(() => import('@/app/pages/course/detail/page'))
const WhoWeAre = lazy(() => import('@/app/edunav/who-we-are/page'))
const WhatWeDo = lazy(() => import('@/app/edunav/what-we-do/page'))
const PurposePage = lazy(() => import('@/app/edunav/purpose/page'))
const ExperiencesPage = lazy(() => import('@/app/edunav/experiences/page'))
const ContactUs = lazy(() => import('@/app/edunav/contact/page'))
const Courses = lazy(() => import('@/app/list/page'))
const AccreditationPage = lazy(() => import('@/app/edunav/accreditation/page'))
const GroundRealityPage = lazy(() => import('@/app/edunav/ground-reality/page'))

//other
const Error404 = lazy(() => import('@/app/(other)/(error-pages)/error-404/page'))
const ComingSoon = lazy(() => import('@/app/coming-soon/page'))
const TermsConditions = lazy(() => import('@/app/edunav/terms-and-conditions/page'))
const PrivacyPolicy = lazy(() => import('@/app/edunav/privacy-policy/page'))

//Auth
const SignIn = lazy(() => import('@/app/(other)/auth/sign-in/page'))
const SignUp = lazy(() => import('@/app/(other)/auth/sign-up/page'))
const ForgotPassword = lazy(() => import('@/app/(other)/auth/forgot-password/page'))

//Instructor
const InstructorDashboard = lazy(() => import('@/app/instructor/dashboard/page'))
const InstructorCourses = lazy(() => import('@/app/instructor/manage-course/page'))
const InstructorCreateCourse = lazy(() => import('@/app/(other)/instructor/create-course/page'))
const InstructorCourseAdd = lazy(() => import('@/app/(other)/instructor/course-added/page'))
const Quiz = lazy(() => import('@/app/instructor/quiz/page'))
const Earnings = lazy(() => import('@/app/instructor/earning/page'))
const StudentsList = lazy(() => import('@/app/instructor/student-list/page'))
const Orders = lazy(() => import('@/app/instructor/order/page'))
const InstructorReviews = lazy(() => import('@/app/instructor/review/page'))
const Payout = lazy(() => import('@/app/instructor/payout/page'))
const EditProfile = lazy(() => import('@/app/instructor/edit-profile/page'))
const Settings = lazy(() => import('@/app/instructor/setting/page'))
const DeleteAccount = lazy(() => import('@/app/instructor/delete-account/page'))

//Student
const StudentDashboard = lazy(() => import('@/app/student/dashboard/page'))
const Subscription = lazy(() => import('@/app/student/subscription/page'))
const StudentCourseList = lazy(() => import('@/app/student/course-list/page'))
const CourseResume = lazy(() => import('@/app/student/course-resume/page'))
const StudentQuiz = lazy(() => import('@/app/student/quiz/page'))
const PaymentInfo = lazy(() => import('@/app/student/payment-info/page'))
const StudentWishlist = lazy(() => import('@/app/student/bookmark/page'))
const StudentEditProfile = lazy(() => import('@/app/student/edit-profile/page'))
const StudentSetting = lazy(() => import('@/app/student/setting/page'))
const StudentDeleteAccount = lazy(() => import('@/app/student/delete-account/page'))

//Admin
const AdminDashboard = lazy(() => import('@/app/admin/dashboard/page'))
const AllCourses = lazy(() => import('@/app/admin/all-courses/page'))
const CourseCategory = lazy(() => import('@/app/admin/course-category/page'))
const CourseDetail = lazy(() => import('@/app/admin/course-detail/page'))
const AdminStudents = lazy(() => import('@/app/admin/students/page'))
const AdminInstructors = lazy(() => import('@/app/admin/instructors/page'))
const AdminInstructorsDetails = lazy(() => import('@/app/admin/instructor-detail/page'))
const AdminInstructorRequests = lazy(() => import('@/app/admin/instructor-requests/page'))
const AdminReviews = lazy(() => import('@/app/admin/reviews/page'))
const AdminEarnings = lazy(() => import('@/app/admin/earnings/page'))
const AdminSettings = lazy(() => import('@/app/admin/admin-settings/page'))
const AdminNotFound = lazy(() => import('@/app/admin/error-404/page'))
const AdminEditCourse = lazy(() => import('@/app/admin/edit-course/page'))


export const edunavRoutes = [
 
  {
    path: '/',
    name: 'EduNav Home',
    element: <EduNavHome />,
  },
  {
    path: '/ground-reality',
    name: 'Ground Reality',
    element: <GroundRealityPage />,
  },
  {
    path: '/who-we-are',
    name: 'Who We Are',
    element: <WhoWeAre />,
  },
  {
    path: '/what-we-do',
    name: 'What We Do',
    element: <WhatWeDo />,
  },
  {
    path: '/purpose',
    name: 'Purpose',
    element: <PurposePage />,
  },
  {
    path: '/experiences',
    name: 'Experiences',
    element: <ExperiencesPage />,
  },
  {
    path: '/contact',
    name: 'Contact Us',
    element: <ContactUs />,
  },
  {
    path: '/courses',
    name: 'Courses',
    element: <Courses />,
  },
  {
    path: '/accreditation',
    name: 'Accreditation',
    element: <AccreditationPage />,
  },
  {
    path: '/pages/course/detail/:courseId',
    name: 'Course Detail',
    element: <Detail />,
  },
  {
    path: '/about-us',
    name: 'About Us',
    element: <WhoWeAre />,
  },
]

const otherRoutes = [
  {
    path: '*',
    name: 'Error 404',
    element: <Error404 />,
  },
  {
    path: '/coming-soon',
    name: 'Coming Soon',
    element: <ComingSoon />,
  },
]
export const authRoutes = [
  {
    path: '/auth/sign-in',
    name: 'Sign In',
    element: <SignIn />,
  },
  {
    path: '/auth/sign-up',
    name: 'Sign Up',
    element: <SignUp />,
  },
  {
    path: '/auth/forgot-password',
    name: 'Forgot Password',
    element: <ForgotPassword />,
  },
  {
    path: '/terms-and-conditions',
    name: 'Terms & Conditions',
    element: <TermsConditions />,
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    element: <PrivacyPolicy />,
  },
]

export const instructorRoutes = [
  {
    path: '/instructor/dashboard',
    name: 'Instructor Dashboard',
    element: <InstructorDashboard />,
  },
  {
    path: '/instructor/manage-course',
    name: 'Instructor Courses',
    element: <InstructorCourses />,
  },
  {
    path: '/instructor/create-course',
    name: 'Instructor Create Course',
    element: <InstructorCreateCourse />,
  },
  {
    path: '/instructor/course-added',
    name: 'Instructor Course Added',
    element: <InstructorCourseAdd />,
  },
  {
    path: '/instructor/quiz',
    name: 'Quiz',
    element: <Quiz />,
  },
  {
    path: '/instructor/earning',
    name: 'Earnings',
    element: <Earnings />,
  },
  {
    path: '/instructor/student-list',
    name: 'Students List',
    element: <StudentsList />,
  },
  {
    path: '/instructor/order',
    name: 'Orders',
    element: <Orders />,
  },
  {
    path: '/instructor/review',
    name: 'Instructor Reviews',
    element: <InstructorReviews />,
  },
  {
    path: '/instructor/payout',
    name: 'Payout',
    element: <Payout />,
  },
  {
    path: '/instructor/edit-profile',
    name: 'Edit Profile',
    element: <EditProfile />,
  },
  {
    path: '/instructor/setting',
    name: 'Settings',
    element: <Settings />,
  },
  {
    path: '/instructor/delete-account',
    name: 'Delete Account',
    element: <DeleteAccount />,
  },
]

export const adminRoutes = [
  {
    path: '/admin/dashboard',
    name: 'Admin Dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/all-courses',
    name: 'All Courses',
    element: <AllCourses />,
  },
  {
    path: '/admin/course-category',
    name: 'Course Category',
    element: <CourseCategory />,
  },
  {
    path: '/admin/course-detail/:courseId',
    name: 'Course Detail',
    element: <CourseDetail />,
  },
  {
    path: '/admin/edit-course/:courseId',
    name: 'Edit Course',
    element: <AdminEditCourse />,
  },
  {
    path: '/admin/students',
    name: 'Admin Students',
    element: <AdminStudents />,
  },
  {
    path: '/admin/instructors',
    name: 'Admin Instructors',
    element: <AdminInstructors />,
  },
  {
    path: '/admin/instructor-detail',
    name: 'Admin Instructor Detail',
    element: <AdminInstructorsDetails />,
  },
  {
    path: '/admin/instructor-requests',
    name: 'Admin Instructor Requests',
    element: <AdminInstructorRequests />,
  },
  {
    path: '/admin/reviews',
    name: 'Admin Reviews',
    element: <AdminReviews />,
  },
  {
    path: '/admin/earnings',
    name: 'Admin Earnings',
    element: <AdminEarnings />,
  },
  {
    path: '/admin/admin-settings',
    name: 'Admin Settings',
    element: <AdminSettings />,
  },
  {
    path: '/admin/not-found',
    name: 'Admin Not Found',
    element: <AdminNotFound />,
  },
]

export const appRoutes = [...edunavRoutes, ...otherRoutes]
